import React from "react"
import {MainCP} from "../../Components/conocimiento-vs-imagen-rostros-tv/MainCP"

const ViewConocimientoVsImagenRostrosTV: React.FC = () => <MainCP/>

export default ViewConocimientoVsImagenRostrosTV;